/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Ready_To_SendInputs */

const en_gift_ready_to_send = /** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to Send`)
};

const es_gift_ready_to_send = /** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para Enviar`)
};

const fr_gift_ready_to_send = /** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt à envoyer`)
};

const de_gift_ready_to_send = /** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit zum Senden`)
};

const id_gift_ready_to_send = /** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap Dikirim`)
};

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const ja_gift_ready_to_send = en_gift_ready_to_send;

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const zh_gift_ready_to_send = en_gift_ready_to_send;

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const ar_gift_ready_to_send = en_gift_ready_to_send;

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const it_gift_ready_to_send = en_gift_ready_to_send;

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const ru_gift_ready_to_send = en_gift_ready_to_send;

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const pt_gift_ready_to_send = en_gift_ready_to_send;

/** @type {(inputs: Gift_Ready_To_SendInputs) => LocalizedString} */
const ko_gift_ready_to_send = en_gift_ready_to_send;

/**
* | output |
* | --- |
* | "Ready to Send" |
*
* @param {Gift_Ready_To_SendInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_ready_to_send = /** @type {((inputs?: Gift_Ready_To_SendInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Ready_To_SendInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_ready_to_send(inputs)
	if (locale === "es") return es_gift_ready_to_send(inputs)
	if (locale === "fr") return fr_gift_ready_to_send(inputs)
	if (locale === "de") return de_gift_ready_to_send(inputs)
	if (locale === "ja") return ja_gift_ready_to_send(inputs)
	if (locale === "zh") return zh_gift_ready_to_send(inputs)
	if (locale === "ar") return ar_gift_ready_to_send(inputs)
	if (locale === "id") return id_gift_ready_to_send(inputs)
	if (locale === "it") return it_gift_ready_to_send(inputs)
	if (locale === "ru") return ru_gift_ready_to_send(inputs)
	if (locale === "pt") return pt_gift_ready_to_send(inputs)
	return ko_gift_ready_to_send(inputs)
});